<template>
  <div class="container-fluid pt-6">
    <div class="row">
      <div class="col-lg-6 col-12 offset-lg-1 clearfix mb-40">
        <div class="pb-container">
          <div v-if="loading" class="pull-left d-block w-100 center mb-20">
            <i class="fa fa-spinner fa-spin fa-3x fa-fw"></i>
            <span class="sr-only">{{ $t('common.loading') }}...</span>
          </div>
          <div v-if="auth.loggedIn">
            <div v-if="$config('updated_enhanced_item').host_count" class="alert alert-warning alert-dismissible fade show">
              <button type="button" class="btn-close" data-bs-dismiss="alert" aria-label="Close"></button>
              <p v-html="$t('plan_builder.updated_enhanced_item', { itemtitle: $config('updated_enhanced_item').item.title, itemoptionsquantity: $config('updated_enhanced_item').item.options.quantity, newitemtitle: $config('updated_enhanced_item').new_item.title, newitemoptionsquantity: $config('updated_enhanced_item').new_item.options.quantity, hostcount: $config('updated_enhanced_item').host_count })"></p>
            </div>
            <div v-if="$config('removed_items') && $config('removed_items').length > 0">
              <div class="alert alert-warning alert-dismissible fade show">
                <button type="button" class="btn-close" data-bs-dismiss="alert" aria-label="Close"></button>
                <p>{{ $t('plan_builder.removed_items') }}</p>
                <p v-for="item in $config('removed_items')" :key="item.title">
                  <b>{{ item.title }}</b>
                </p>
                <p v-html="$t('plan_builder.billing_management')"></p>
              </div>
            </div>
            <div v-if="$config('removed_expired_items') && $config('removed_expired_items').length > 0">
              <div v-show="!loading" class="alert alert-warning alert-dismissible fade show">
                <button type="button" class="btn-close" data-bs-dismiss="alert" aria-label="Close"></button>
                <p>{{ $t('plan_builder.open_invoice') }}</p>
                <p v-for="item in $config('removed_expired_items')" :key="item.title">
                  <b>{{ item.title }}</b>
                </p>
                <p v-html="$t('plan_builder.invoice_link')"></p>
              </div>
            </div>
          </div>
          <div v-if="$config('removed_pro_items') && $config('removed_pro_items').length > 0">
            <div v-show="!loading" class="alert alert-warning alert-dismissible fade show">
              <button type="button" class="btn-close" data-bs-dismiss="alert" aria-label="Close"></button>
              <p>{{ $t('plan_builder.pro_removed_conflict') }}</p>
              <p v-for="item in $config('removed_pro_items')" :key="item.title">
                <b>{{ item.title }}</b>
              </p>
              <p v-html="$t('plan_builder.pro_removed_conflict_link')"></p>
            </div>
          </div>
          <div v-if="cart_items == 0" class="pull-left d-block w-100">
            <div class="pb-terms pb-w-100 ps-4 pe-4 pt-3">
              <div class="title">
                <span class="fw-semibold">{{ $t('plan_builder.empty_cart') }}</span>
              </div>
              <span v-html="$t('plan_builder.purchase_services')"></span>
            </div>
          </div>
          <div v-for="(item, index) in cart_items" :key="item.id">
            <product :item="item" :errors="getItemErrors(item.id)" :global-term="globalTerm" :inclusions="getProductInclusions(index)" />
          </div>
          <div v-if="undo_option" class="pull-left d-block w-100">
            <div class="pb-terms pb-grey-bck ps-4 pe-4 pt-3">
              <div class="pull-left w-100 mb-3 d-flex flex-row justify-content-between gap-2 align-items-center">
                <button class="delete btn btn-xs btn-danger pr-lg auto-width" @click.prevent="dismissRemovalOption" v-track="{ category: 'plan-builder', action: 'click', label: 'dismiss_remove_button' }">
                  <i type="button" class="fa fa-remove"></i>
                </button>
                <div class="ml-auto pb-total mb-0">
                  {{ $t('plan_builder.item_removed') }}
                  <a v-track="{ category: 'plan-builder', action: 'click', label: 'undo-removal' }" @click="undoRemoval" role="button" class="text-info text-decoration-none">{{ $t('plan_builder.undo') }}.</a>
                </div>
              </div>
            </div>
          </div>
          <div v-if="globalTerm" class="pull-left d-block w-100">
            <div class="pb-terms pb-grey-bck pb-w-100 pl-30 pr-30 pt-20">
              <div class="title sub-title">
                <span v-html="$t('plan_builder.select_term')"></span>
              </div>
              <div class="pb-terms mb-0">
                <div class="term-container pull-left d-block">
                  <select-box v-for="term in [1, 2, 3, 5, 10]" :key="term" v-track="{ category: 'plan-builder', action: 'click', label: 'global-term-selection' }" :active="globalTerm === term" :styles="{ col: 'colpb-sm-1 col-xs-6 term-col' }" @click.native="selectedTerm = term">
                    <p slot="text" class="term-title">{{ term }} {{ $t('plan_builder.years') }}</p>
                  </select-box>
                </div>
              </div>
            </div>
          </div>
        </div>

        <account v-if="!auth.loggedIn"></account>
      </div>
      <div class="col-lg-4 col-12 order-summary pl-lg-0 pr-lg-0" id="order_preview">
        <component :is="upsell_suggestion"></component>
        <div class="pb-container d-block pull-left" id="cart-preview">
          <div class="pb-grey-bck pb-terms ps-3 pe-3 pt-3 mt-n2">
            <div class="pb-title-row d-flex flex-row gap-2">
              <h2 class="pull-left pb-title w-100 fs-5">
                {{ $t('domain_contact.order_summary.order_summary') }}
              </h2>
            </div>
            <order-summary :authenticated="auth.loggedIn" :cartItems.sync="cart_items" :cart-total="cart_total" :invoice-preview.sync="invoice_preview" :addonItems="addon_items" :hasEmailPromo="$config('has_email_promo')" />
            <div v-if="auth.loggedIn" class="pb-terms">
              <div class="pull-left w-100 mb-0 pl-md-0 pr-md-0">
                <button :disabled="loading || disableSubmission" class="btn-os btn btn-success pull-left-sm text-bold order-sm-1" @click="submitCart">
                  <i v-if="loading" class="fa fa-spinner fa-spin"></i>
                  <div v-else>{{ $t('plan_builder.proceed_to_checkout') }}</div>
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import Errors from '../../classes/errors';
import Account from './account/Account.vue';
import SelectBox from './SelectBox.vue';
import Product from './products/Product.vue';
import OrderSummary from './OrderSummary.vue';
import DnsTierUpsell from './upsells/DnsTierUpsell.vue';
import EnhancedUpsell from './upsells/EnhancedUpsell.vue';
import PriorityUpsell from './upsells/PriorityUpsell.vue';
import RapidWildcardUpsell from './upsells/RapidWildcardUpsell.vue';
import RapidBasicUpsell from './upsells/RapidBasicUpsell.vue';

import { mapActions, mapState } from 'vuex';
import { ENGLISH } from '../store/modules/locale';
import TeamLoginUpsell from './upsells/TeamLoginUpsell.vue';

export default {
  name: 'PlanBuilder',

  components: {
    Account,
    SelectBox,
    Product,
    OrderSummary,
    'dns.tier': DnsTierUpsell,
    'account.enhanced': EnhancedUpsell,
    'support.priority': PriorityUpsell,
    'ssl.rapid_wildcard_dv': RapidWildcardUpsell,
    'ssl.rapid_dv': RapidBasicUpsell,
    'team.login': TeamLoginUpsell
  },

  data() {
    return {
      selectedTerm: null,
      cart_errors: {},
      loading: false
    };
  },

  computed: {
    ...mapState({
      cart_items: state => state.cart.items,
      upsell_suggestion: state => state.cart.upsell_suggestion,
      addon_items: state => state.cart.addon_items,
      cart_total: state => state.cart.total,
      auth: state => state.auth,
      undo_option: state => state.cart.undo_option,
      lang: state => state.locale.lang,
      invoice_preview: state => state.cart.invoice_preview
    }),
    privateRegAddOns: function () {
      return this.addon_items.filter(addon => {
        return addon.product_id == 'registration.privacy';
      });
    },
    sslItems: function () {
      return this.cart_items.filter(item => {
        return item.product_id.indexOf('ssl') != -1;
      });
    },
    hostRedemptionItem: function () {
      return this.cart_items.filter(item => {
        return item.product_id.indexOf('host.redemption') != -1;
      });
    },
    transferItems: function () {
      return this.cart_items.filter(item => {
        return item.product_id.indexOf('registration.transfer') != -1;
      });
    },
    globalTerm: function () {
      const non_monthly_termed_items = this.cart_items.filter(item => {
        return item.term === term && item.options.term_type !== 'monthly';
      });

      if (this.sslItems.length > 0 || non_monthly_termed_items.length < 2) {
        return false;
      }
      if (this.transferItems.length > 0 || non_monthly_termed_items.length < 2) {
        return false;
      }
      if (this.hostRedemptionItem.length > 0) {
        return false;
      }

      const term = this.cart_items[0].term;

      return non_monthly_termed_items.length > 0 ? false : term;
    },
    disableSubmission: function () {
      return this.cart_items.length == 0;
    }
  },

  created() {
    this.loading = true;
    this.getCartItems(true)
      .then(() => {
        this.loading = false;
        // eslint-disable-next-line no-undef
        $('.tip').tooltip();
      })
      .catch(() => {
        this.loading = false;
      });
  },

  updated() {
    if (this.selectedTerm == null) {
      this.selectedTerm = this.globalTerm;
    }
  },

  methods: {
    ...mapActions('cart', ['getCartItems', 'updateCartGlobalTerm', 'undoRemoval', 'dismissRemovalOption']),

    submitCart() {
      this.loading = true;
      let localePrefix = this.lang !== ENGLISH ? '/' + this.lang : '';
      // eslint-disable-next-line no-undef
      axios
        .post(`${localePrefix}/plan-builder/submit`)
        .then(response => {
          this.loading = false;

          if (response.data.redirect) {
            window.location.href = response.data.redirect;
          }
        })
        .catch(error => {
          this.loading = false;
          this.cart_errors = error.response.data.errors;
          this.$nextTick(function () {
            // eslint-disable-next-line no-undef
            if ($('.has-error').length > 0) {
              // eslint-disable-next-line no-undef
              $('html, body').animate({ scrollTop: $('.has-error').offset().top - 50 });
            }
          });
        });
    },

    getPrivateRegAddOn(reg_item_id) {
      for (let addon of this.privateRegAddOns) {
        if (addon.parent_id === reg_item_id) {
          return addon;
        }
      }

      return null;
    },

    getItemErrors(item_id) {
      let item_errors = new Errors();

      if (Object.prototype.hasOwnProperty.call(this.cart_errors, item_id) && this.cart_errors[item_id].length > 0) {
        if (typeof this.cart_errors[item_id][0] === 'string') {
          item_errors.set({ conflicts: [this.cart_errors[item_id][0]] });
        } else {
          item_errors.set(this.cart_errors[item_id][0]);
        }

        return item_errors;
      }
      return item_errors;
    },
    getProductInclusions(index) {
      let subscriptions = this.invoice_preview.subscriptions;

      const subscription = subscriptions[index];

      if (!subscription) {
        console.warn(`Expected subscription from index ${index}, got none;`);
        return [];
      }

      let billing_plans = subscription.billing_plans;

      return billing_plans
        .map(function (billing_plan) {
          if (billing_plan.show_entitlements) {
            return billing_plan.entitlements.map(function (entitlements) {
              if (entitlements.show_description) {
                return entitlements.description;
              }
            });
          } else {
            return billing_plan.title;
          }
        })
        .flat();
    }
  },

  watch: {
    selectedTerm: function (val) {
      if (val) {
        this.loading = true;
        var item_ids = [];
        for (var item in this.cart_items) {
          const cart_item = this.cart_items[item];
          if (cart_item.term !== val && cart_item.options.term_type !== 'monthly') {
            item_ids.push(this.cart_items[item].id);
          }
        }
        this.updateCartGlobalTerm({
          term: val,
          item_ids: item_ids
        })
          .then(() => {
            this.loading = false;
          })
          .catch(() => {
            this.loading = false;
          });
      }
    }
  }
};
</script>
